// English strings (source language): Bluetooth devices (trainer, heart rate, controllers).

const en = {
  actions: {
    steerLeft: 'Move left',
    steerRight: 'Move right',
    fire: 'Use item',
    gearUp: 'Shift up',
    gearDown: 'Shift down',
    look: 'Look back',
    camera: 'Change view',
    pause: 'Pause',
  },
  /** Generic names of the five arcade game buttons (touch overlay). */
  gameButtons: { left: 'Left', right: 'Right', fire: 'Action', up: 'Up', down: 'Down' },
  notConnected: 'not connected',
  notConnectedPlural: 'not connected',
  connecting: 'connecting…',
  disconnected: 'disconnected',
  nameDisconnected: (name: string) => `${name} disconnected`,
  bluetoothOff: (reason: string) => `Bluetooth unavailable (${reason}). Check that it is on, that the system settings allow this browser (on a Mac: Privacy & Security › Bluetooth) and that the browser lets sites use it.`,
  bluetoothBlocked: (reason: string) =>
    `This browser blocks Web Bluetooth (${reason}). Brave, Opera and Vivaldi turn it off by default: enable it in the browser's flags (Brave: brave://flags, "Web Bluetooth API") and relaunch, or use Chrome or Edge.`,
  unsupported: (name: string) => `${name || 'This device'} is not a supported device`,
  connectFailed: (name: string) => `Could not connect ${name || 'this device'}: it may be in use by another app`,
  noBluetooth: 'Web Bluetooth unavailable: use Chrome or Edge, on an https or localhost page.',
  noBluetoothShort: 'Web Bluetooth unavailable: use Chrome or Edge.',
  trainer: 'Smart trainer',
  hr: 'Heart rate',
  powerMeter: 'Power meter',
  speedCadence: 'Speed/cadence sensor',
  reconnecting: (n: number, max: number) => `reconnecting… (${n}/${max})`,
  /** Generic classic-trainer curves (branded models keep their commercial name). */
  curves: { 'generic-fluid': 'Generic fluid', 'generic-magnetic': 'Generic magnetic (medium resistance)', 'generic-air': 'Generic wind (fan)' } as Record<
    string,
    string
  >,
  kinds: { fluid: 'fluid', magnetic: 'magnetic', air: 'wind' },
  controlled: ' · controlled resistance',
  pressToTest: (names: string) => `${names} · press a button to test`,
  /** Zwift Ride controller buttons, by bit number. */
  buttons: {
    0: 'Left',
    1: 'Up',
    2: 'Right',
    3: 'Down',
    4: 'A',
    5: 'B',
    6: 'Y',
    8: 'Z',
    9: 'Shift + (left)',
    10: 'Shift − (left)',
    11: 'Left power-up',
    12: 'Left on/off',
    13: 'Shift + (right)',
    14: 'Shift − (right)',
    16: 'Right power-up',
    17: 'Right on/off',
  } as Record<number, string>,
  button: (n: string) => `Button ${n}`,
};
export default en;
